// @flow
import {
  navigationActionTypes as ActionType,
  navigationTypes as Types
} from '../constants';

const initialState = {
  page: 'chooseOrchPage',
  prevPage: ''
};

export default function NavigationReducer(
  state: Types.InitialState = initialState,
  action: Types.Action
) {
  switch (action.type) {
    case ActionType.SWITCH_PAGE: {
      const nextPage = action.payload.page;
      return {
        ...state,
        prevPage: state.page,
        page: nextPage
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/navigation.js